// 简化版权限指令，直接从localStorage读取权限信息
const hasPermission = (el, binding) => {
  const { value } = binding
  
  if (!value) {
    return
  }
  
  try {
    // 从localStorage读取权限信息
    const permissionsStr = localStorage.getItem('admin-permissions') || '[]'
    const permissions = JSON.parse(permissionsStr)
    
    // 如果权限列表为空或包含'*'，表示拥有所有权限
    if (!permissions || permissions.length === 0 || permissions.includes('*')) {
      return
    }
    
    const hasPerm = permissions.includes(value)
    
    if (!hasPerm) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  } catch (error) {
    console.error('权限检查出错:', error)
    // 出错时不隐藏元素，避免影响用户体验
  }
}

export default {
  mounted(el, binding) {
    hasPermission(el, binding)
  },
  updated(el, binding) {
    hasPermission(el, binding)
  }
}